module.exports = __webpack_public_path__ + "img/28.9918b4dd.png";